import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const CBJCompliance: React.FC = () => {
  const sections = [
    {
      title: 'Central Bank of Jordan Compliance',
      content: 'The Central Bank of Jordan (CBJ) has established comprehensive cybersecurity regulations for financial institutions operating in Jordan. Our specialized team provides expert guidance to ensure full compliance with CBJ cybersecurity requirements, helping financial institutions maintain regulatory compliance while strengthening their security posture.',
      benefits: [
        'Comprehensive CBJ regulation interpretation and implementation',
        'Cybersecurity governance framework development',
        'Risk management and assessment programs',
        'Incident response and business continuity planning',
        'Regular compliance monitoring and reporting'
      ]
    },
    {
      title: 'CBJ Cybersecurity Framework',
      content: 'We help financial institutions implement the CBJ cybersecurity framework across all required domains, ensuring comprehensive coverage of regulatory requirements.',
      benefits: [
        'Cybersecurity governance and oversight',
        'Cybersecurity risk management',
        'Cybersecurity controls and safeguards',
        'Cyber incident response and recovery',
        'Cybersecurity testing and assurance'
      ]
    },
    {
      title: 'Compliance Monitoring',
      content: 'Ongoing compliance requires continuous monitoring and regular reporting to the CBJ. We provide comprehensive support for maintaining compliance status.',
      benefits: [
        'Quarterly and annual compliance reporting',
        'Continuous control monitoring and testing',
        'Regulatory update tracking and implementation',
        'Internal audit and assessment programs',
        'Remediation planning and execution'
      ]
    }
  ];

  const sidebarInfo = [
    {
      title: 'Regulatory Requirements',
      content: 'CBJ cybersecurity regulations apply to all licensed financial institutions including banks, insurance companies, and financial services providers.'
    },
    {
      title: 'Implementation Timeline',
      content: 'CBJ compliance implementation typically requires 4-8 months depending on current security maturity and organizational size.'
    },
    {
      title: 'Expert Team',
      content: 'Our consultants have extensive experience with Middle Eastern financial regulations and CBJ requirements.'
    }
  ];

  return (
    <ServiceTemplate
      title="CBJ Compliance"
      subtitle="Specialized compliance services for Central Bank of Jordan cybersecurity regulations, ensuring financial institutions meet all regulatory requirements."
      sections={sections}
      ctaTitle="Achieve CBJ Compliance"
      ctaDescription="Navigate complex CBJ cybersecurity regulations with our specialized financial services compliance expertise."
      sidebarInfo={sidebarInfo}
    />
  );
};

export default CBJCompliance;

